import React from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import SqftFeaturesPopupFeature from "./sqftFeaturesPopupFeature";
import {getFeatureGroupName} from "../../../misc/helpers";
import {SQFT_FEATURES} from "../../sqft/constants";

const SqftFeaturesPopupParentList = (props) => {

  const {parentsList, parentsLists, setParentsLists, intl, fabricatorData} = props;

  if (!parentsList) {
    return null
  }

  return (
    <div className="ui-popup__body-parentlist">
      {Object.keys(parentsList).map(parentKey => {
        const parent = parentsList[parentKey];
        if (!parent || !parent.features || !parent.features.length) {
          return null
        }
        let featureGroupName = "";
        switch (parentKey) {
          case SQFT_FEATURES.slabs:
            featureGroupName = <FormattedMessage id={"sqftFeaturesPopup.title.slabs"}/>;
            break
          default:
            featureGroupName = getFeatureGroupName(parent.subPart.part, intl, fabricatorData);
        }

        return (
          <div className="sqft-popup__group" key={parentKey}>
            <div className="sqft-popup__title">
              <span className={"selection-footer-list__item-icon sqft-popup__title-icon sqft-popup__title-icon--" + parentKey}/>
              <span className="sqft-popup__title-text">
                {featureGroupName}
              </span>
            </div>
            <ul className="sqft-popup__list">
              {parent.features.map((sqftFeature, sqftFeatureIndex) => (
                <SqftFeaturesPopupFeature key={"sqftFeature" + sqftFeatureIndex}
                                          parentKey={parentKey}
                                          parentsList={parentsList}
                                          parentsLists={parentsLists}
                                          setParentsLists={setParentsLists}
                                          sqftFeatureIndex={sqftFeatureIndex} />
              ))}
            </ul>
          </div>
        )
      })}
    </div>
  )
};

SqftFeaturesPopupParentList.propTypes = {
  parentsList: PropTypes.object,
  parentsLists: PropTypes.array,
  setParentsLists: PropTypes.func.isRequired,
}

const mapStateToProps = (store) => {
  return {
    fabricatorData: store.fabricatorState
  };
};
const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SqftFeaturesPopupParentList)
)
